<template>
  <ol class="list-decimal">
    <li>
      {{ i18n(translations.createBlankCsvInstruction) }}

      <ul class="body-2 mb-4 ml-4 mt-2">
        <li>{{ i18n(translations.skuColumn) }}</li>
        <li>{{ i18n(translations.businessNameColumn) }}</li>
        <li>{{ i18n(translations.addressLine1Column) }}</li>
        <li>{{ i18n(translations.addressLine2Column) }}</li>
        <li>{{ i18n(translations.postalCodeColumn) }}</li>
        <li>{{ i18n(translations.cityColumn) }}</li>
        <li>{{ i18n(translations.countryColumn) }}</li>
        <li>{{ i18n(translations.phoneNumberColumn) }}</li>
        <li>{{ i18n(translations.emailAddressColumn) }}</li>
        <li>{{ i18n(translations.websiteColumn) }}</li>
      </ul>
    </li>
    <li>
      {{ i18n(translations.fillInDetails) }}
    </li>
    <li>
      {{ i18n(translations.uploadCompletedCsv) }}
    </li>
  </ol>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '../Form.translations'

const i18n = useI18n()
</script>
